<template>
  <v-app>
    <v-navigation-drawer
      v-model="menudrawer"
      width="85%"
      temporary
      right
      style="background-color:#fafafa"
      @input="capture($event)"
      app
      id="sidebar"
      v-bind:touchless="loggedOut"
    >
      <Sidebar
        v-bind:userData="userData"
        v-bind:userId="userId"
        v-bind:owner="owner"
        v-bind:storeData="storeData"
        v-bind:subscriptions="subscriptions"
        v-bind:selectedLocation="selectedLocation"
        @refresh-merchant-profile="GetOwnerProfile()"
        @refresh-location-details="Refresh('sidebar')"
        @relogin="ToRelogin($event)"
        @logout="logout($event)"
        :key="'sidebar' + refresh"
        app
      ></Sidebar>
    </v-navigation-drawer>
    <v-app-bar
      v-show="!loggedOut"
      flat
      color="white"
      fixed
      app
      width="640px"
      style="margin: 0 auto;"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <v-img
          max-height="40"
          max-width="100"
          src="~/img/wiom_logo.png"
          style="margin-left: 80px;"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <Notifications 
        v-if="selectedLocation && selectedLocation.nasid"
        :key="'notifications::' + selectedLocation.nasid"
        v-bind:userData="userData"
        v-bind:selectedLocation="selectedLocation"
        />
      <v-app-bar-nav-icon
        @click.stop="toggleMenu()"
        color="black"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-content :id="loggedOut">
      <v-container fluid>
        <v-dialog v-model="showTroubleShooting" persistent max-width="90%">
          <Troubleshoot
            v-on:cancel="showTroubleShooting = false"
          ></Troubleshoot>
        </v-dialog>
        <!-- If using vue-router <router-view></router-view> -->
        <!--<Login v-if="loggedOut && showLogin" @sign-in="signedIn($event)" v-bind:toRelogin="toRelogin" ></Login>
        <v-img v-if="!showLogin && loggedOut" src="img/icons/favicon-196.png" width="192" style="margin: 0px auto;margin-top:25%"></v-img>-->
        <Dashboard
          v-if="!loggedOut"
          v-bind:userId="userId"
          v-bind:userData="userData"
          :key="userId +'::'+ selectedSection +'::'+ refresh"
          v-bind:selectedSection="selectedSection"
          v-bind:showNotifications="showNotifications"
          v-bind:selectSection="selectSection"
          v-bind:selectTab="selectTab"
          v-bind:selectNasid="selectNasid"
          @get-owner-details="setOwnerDetails($event)"
          @get-locations="setLocations($event)"
          @location-selected="locationSet($event)"
          @update-loc-details="UpdateLocation()"
          @update-merch-details="UpdateMerchant()"
          @got-inactive-locations="inactiveLocationsCount = $event"
        ></Dashboard>
      </v-container>
    </v-content>

    <v-footer
      :id="loggedOut"
      app
      :style="{ margin: '0 auto', 'max-width': '640px' }"
    >
      <v-bottom-navigation
        v-if="!loggedOut"
        v-model="section"
        :style="{ background: '#f3f3f3' }"
        absolute
        grow
        color="white"
        :fixed="true"
      >
        <v-btn
          id="manageBtn"
          value="manage"
          max-width="100%"
          @click="setSelectedSection('manage')"
        >
          <span class="fs-12 fw-700">Your Wi-Fi</span>
          <b style="font-size:16px;">Manage</b>
        </v-btn>
        <v-divider vertical></v-divider>
        <v-btn
          id="valueBtn"
          value="values"
          max-width="100%"
          @click="setSelectedSection('value')"
        >
          <span class="fs-12 fw-700">Your Business</span>
          <b style="font-size:16px;">Grow</b>
        </v-btn>
      </v-bottom-navigation>
    </v-footer>
  </v-app>
</template>

<script>
import Sidebar from "./components/common/Sidebar";
//import Login from "./components/common/Login";
import Dashboard from "./components/common/Dashboard";
import Troubleshoot from "./components/common/Troubleshoot";
import Notifications from "./components/common/Notifications";
import helper from "./utils/helper";
import axios from "./plugins/axios";
import firebase from "./plugins/firebase";
const { messaging } = firebase;
import WIOM_APIS from './utils/wiom-apis';
export default {
  name: "App",
  props: ["selectSection", "selectTab"],
  methods: {
    ToRelogin: function(data) {
      this.toRelogin = Object.assign({}, this.toRelogin, data);
      console.log("LOGGING IN AGAIN WITH NEW PASSWORD", data, this.toRelogin);
    },
    nonPremium: function(location) {
      if (location.subscription && location.subscription.active == true)
        return false;
      return true;
    },
    signedIn: function(userData) {
      this.popup.visbile = true;
      this.popup.text = "Signed In";
      this.popup.type = "success";
      this.loggedOut = false;
      this.userData = userData;
      this.userId = userData.userid;
      this.showLogin = false;
      //window.heap.identify(userData.userid);
      //console.log(this.userId, this.userData);
      window.scrollTo(0, 0);
    },
    toggleMenu: function() {
      window.document.getElementById("sidebar").style.height =
        window.document.documentElement.clientHeight;
      window.scrollTo(0, document.body.scrollHeight + 200);
      this.menudrawer = !this.menudrawer;
      //console.log(this.menudrawer);
    },
    ShowTroubleShooting: function() {
      this.showTroubleShooting = true;
    },
    showNotifications: function() {
      this.notifications = true;
    },
    getNotifications: function() {
      window.scrollTo(0, 0);
      this.inactiveLocationsCount = 0;
      this.inactiveLocations = [];
    },
    locationSet: function(location) {
      console.log("LOCATION SET", location);
      this.selectedLocation = location;
      if(messaging) {
        messaging
          .getToken({
            vapidKey:
              "BOXbazgYMUz7_AHG9mteFqXlKYYmTNnwfbK-nhQihCkYJvbQWQTFy38Vcscb3W2X4OhzhxKW4A_1PJtXaTprLBM"
          })
          .then(currentToken => {
          if (currentToken) {
            helper.setCookie("push-token", currentToken);
            // Send the token to your server and update the UI if necessary
            axios.post("/wiom/SaveNotificationToken", {
              token: currentToken,
              nasid: location.nasid,
              adminid: this.userId
            }).then(function(response) {
              console.log("saved token",response);
            })
            .catch(function(error) {
              console.log("error saving",  error);
            });
            console.log("This is the current Token", currentToken);
          } else {
            // Show permission request UI
            console.log(
              "No registration token available. Request permission to generate one."
            );
            if (messaging) {
              Notification.requestPermission()
                .then(() => {
                  console.log("Notification permission granted.");
                  messaging.getToken().then(token => {
                    console.log(token);
                })
                })
                .catch(err => {
                  console.log("Unable to get permission to notify.", err);
              });
            }
          }
        }).catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
      }
      this.getNotifications();
      helper.setCookie("selectedLocation", location.nasid);
    },
    setLocations: function(locations) {
      this.storeData = locations;
    },
    setSelectedSection: function(section) {
      this.selectedSection = section;
    },
    setOwnerDetails: function(owner) {
      this.owner = owner;
    },
    logout: function() {
      this.popup.visbile = true;
      this.popup.text = "Logged Out";
      this.popup.type = "success";
      this.loggedOut = true;
      this.userData = null;
      this.userId = null;
      this.showLogin = true;
      helper.deleteCookie("token");
      helper.deleteCookie("userData");
      helper.deleteCookie("loggedIn");
      helper.deleteCookie("i2e1-admin-token");
      helper.deleteCookie("i2e1-admin-view-token");
      helper.deleteCookie("sessionId");
      helper.deleteCookie("mobile");
      helper.deleteCookie("appId");      
      helper.deleteCookie("selectedLocation");
      helper.deleteCookie("skip-plan");
     
      WIOM_APIS.logout().then(response=> {
        console.log(response)
        setTimeout(() => {
          window.location.href = window.location.origin  
        }, 2000);
      });
    },
    Refresh: function(name) {
      console.log("Refresh " + name);
      this.refresh = !this.refresh;
    },
    UpdateLocation: function() {
      this.popup = {
        visbile: true,
        text: "Location Details Updated",
        type: "success"
      };
      this.Refresh("sidebar");
    },
    UpdateMerchant: function() {
      this.popup = {
        visbile: true,
        text: "Merchant Details Updated",
        type: "success"
      };
      this.Refresh("sidebar");
    },
    GetOwnerProfile: function() {},
    capture: function(event) {
      if (event == false) window.scrollTo(0, 0);
    }
  },
  mounted: function() {
    let that = this;
    console.log("select the section: ", that.selectSection, that.selectedSection);
    if (that.selectSection)
      this.setSelectedSection(that.selectSection);
    WIOM_APIS.fetchUser().then(function(userData) {
      that.$emit("sign-in", userData);
      that.signedIn(userData)
    })
  },
  components: {
    Sidebar,
    //Login,
    Dashboard,
    Troubleshoot,
    Notifications
  },
  data: function() {
    return {
      toRelogin: {
        username: null,
        password: null
      },
      popup: {
        type: "info",
        visbile: false,
        text: ""
      },
      showLogin: false,
      subscriptions: {},
      refresh: false,
      section: 0,
      loggedOut: true,
      userId: 0,
      menudrawer: false,
      notifications: false,
      userData: null,
      selectedSection: "manage",
      owner: {},
      storeData: [],
      selectedLocation: null,
      inactiveLocationsCount: 0,
      inactiveLocations: [],
      showTroubleShooting: false,
      selectNasid: this.$route.params.selectNasid
    };
  },
  watch: {
    inactiveLocations: function() {}
  }
};
</script>
